(() => {
  if (customElements.get('hitch-load-more')) return;

  const returnKey = 'hitch-collection-return';

  class HitchLoadMore extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
      this.rememberProduct = this.rememberProduct.bind(this);
    }

    connectedCallback() {
      this.link = this.querySelector('.hitch-load-more__button');
      this.grid = this.closest('.hitch-product-grid-shell')?.querySelector('#product-grid');
      this.link?.addEventListener('click', this.handleClick);
      this.grid?.addEventListener('click', this.rememberProduct);
    }

    disconnectedCallback() {
      this.link?.removeEventListener('click', this.handleClick);
      this.grid?.removeEventListener('click', this.rememberProduct);
    }

    rememberProduct(event) {
      const link = event.target.closest('a[href*="/products/"]');
      if (!link) return;
      try {
        sessionStorage.setItem(returnKey, JSON.stringify({
          collection: `${location.pathname}${location.search}`,
          product: new URL(link.href).pathname,
        }));
      } catch (_) {
        // Browsing still works when session storage is unavailable.
      }
    }

    async handleClick(event) {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (!this.grid || !this.link) return;
      event.preventDefault();
      if (this.loading) return;

      const nextUrl = new URL(this.link.href, location.href);
      const sectionUrl = new URL(nextUrl);
      sectionUrl.searchParams.set('section_id', this.dataset.sectionId);
      this.loading = true;
      this.setAttribute('aria-busy', 'true');
      const error = this.querySelector('.hitch-load-more__error');
      if (error) error.hidden = true;

      try {
        const response = await fetch(sectionUrl, { headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error(`Collection request failed: ${response.status}`);
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const sourceGrid = page.querySelector('#product-grid');
        const sourceControl = page.querySelector('hitch-load-more');
        const newItems = Array.from(sourceGrid?.children || []).filter((item) => item.matches('li.grid__item'));
        if (!sourceControl || !newItems.length) throw new Error('Collection page has no products');
        if (!this.isConnected || !this.grid.isConnected) return;

        newItems.forEach((item) => {
          item.querySelectorAll('.scroll-trigger').forEach((animated) => animated.classList.add('scroll-trigger--cancel'));
          item.classList.add('scroll-trigger--cancel');
        });
        this.grid.append(...newItems);

        const visible = Number(sourceControl.dataset.visible);
        this.dataset.visible = String(visible);
        this.querySelector('[data-hitch-visible]').textContent = String(visible);
        this.querySelector('.hitch-load-more__progress').style.width = `${Math.min(100, visible / Number(this.dataset.total) * 100)}%`;

        const nextLink = sourceControl.querySelector('.hitch-load-more__button');
        if (nextLink) {
          this.link.href = new URL(nextLink.getAttribute('href'), nextUrl).href;
        } else {
          this.link.remove();
          this.link = null;
        }

        const searchParams = nextUrl.search.slice(1);
        history.replaceState({ ...history.state, searchParams }, '', `${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}`);
        if (typeof FacetFiltersForm !== 'undefined') FacetFiltersForm.searchParamsPrev = searchParams;

        const firstProductLink = newItems[0].querySelector('a[href*="/products/"]');
        firstProductLink?.focus({ preventScroll: true });
        newItems[0].scrollIntoView({ block: 'start' });
      } catch (failure) {
        if (error && this.isConnected) {
          error.textContent = 'No pudimos cargar más productos. Inténtalo de nuevo.';
          error.hidden = false;
        }
      } finally {
        this.loading = false;
        this.removeAttribute('aria-busy');
      }
    }
  }

  customElements.define('hitch-load-more', HitchLoadMore);

  window.addEventListener('pageshow', (event) => {
    if (event.persisted || performance.getEntriesByType('navigation')[0]?.type !== 'back_forward') return;
    try {
      const previous = JSON.parse(sessionStorage.getItem(returnKey));
      if (previous?.collection !== `${location.pathname}${location.search}`) return;
      const product = Array.from(document.querySelectorAll('#product-grid a[href*="/products/"]'))
        .find((link) => new URL(link.href).pathname === previous.product);
      if (product) requestAnimationFrame(() => requestAnimationFrame(() => product.scrollIntoView({ block: 'center' })));
    } catch (_) {
      // Let the browser restore its own scroll position.
    }
  });
})();
